module.exports = __webpack_public_path__ + "static/pros-036a4c36fb75c4d6f3eed4ee777ffea6.png";